import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import { getResults } from '../../services/results/resultsService';
import { Button } from "../../../../../components/forms/Buttons/Button";
import { getFinalResultsFiles } from "../../../../../services/olympiad/resultsFilesService";
import Select from "../../../../../components/forms/Select/Select";
import SimpleLoader from "../../../../../components/Loader/SimpleLoader";
import {
  ArchiveBoxIcon,
  ArrowUpTrayIcon,
  CheckIcon,
  EyeIcon,
} from "@heroicons/react/24/solid";
import { UserContext } from "../../../../../utils/contexts/UserContext";
import CREATE from "./CRUD/CREATE";
import FileCard from "./CRUD/FileCard";

export default function NewUploadResults() {
  // const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [resultsFiles, setResultsFiles] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    getFinalResultsFiles({ signal }).then((res) => {
      setResultsFiles(res.results);
      setCount(res.count);
    });
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <>
      <CREATE
        onCreate={(res) => {
          setResultsFiles((prev) => [...prev, res]);
          setCount((prev) => prev + 1);
        }}
      />
      count: {count}
      {resultsFiles.map((file) => {
        return (
          <FileCard
            file={file}
            key={file.uuid}
            onDelete={() => {
              setResultsFiles((prev) =>
                prev.filter((ele) => ele.uuid !== file.uuid)
              );
              setCount((prev) => prev - 1);
            }}
          />
        );
      })}
    </>
  );
}
